/**
 * Начальные положения мышц и суставов (в градусах)
 * Ключи должны совпадать с ключами CSV / frameKeyMap
 * offset — прибавляется к значению из CSV
 * invert — если true, значение из CSV умножается на -1
 */
export const initialMuscleRotations: Record<
    string,
    { offset: number; invert?: boolean }
> = {
    // Пример для ног
    тазобедренный_сустав_л_сгибание: { offset: 0, invert: true },
    тазобедренный_сустав_л_отведение: { offset: 180, invert: true   },
    коленный_сустав_л_сгибание: { offset: -10 },
    голеностопный_сустав_л_сгибание: { offset: 60 },
    голеностопный_сустав_л_отведение: { offset: 0 },

    тазобедренный_сустав_п_сгибание: { offset: 0, invert: true  },
    тазобедренный_сустав_п_отведение: { offset: -180, invert: false },
    коленный_сустав_п_сгибание: { offset: -10 },
    голеностопный_сустав_п_сгибание: { offset: 60 },
    голеностопный_сустав_п_отведение: { offset: 0 },
    // Пример для рук
    плечевой_сустав_л_сгибание: { offset: 0 , invert: false},
    плечевой_сустав_л_подъем: { offset: 50 , invert: true },
    локтевой_сустав_л_сгибание: { offset: -10 , invert: true},
    лучезапястный_сустав_л_отведение: { offset: 90, invert: false},
    лучезапястный_сустав_л_сгибание: { offset: 90, invert: true},

    плечевой_сустав_п_сгибание: { offset: -0, invert: true},
    плечевой_сустав_п_подъем: { offset: 50 , invert: true },
    локтевой_сустав_п_сгибание: { offset: 10, invert: true },
    лучезапястный_сустав_п_отведение: { offset: 90, invert: false },
    лучезапястный_сустав_п_сгибание: { offset: -90, invert: false},
    // Пример для позвоночника
    позвоночник_наклон_в_стороны: { offset: 0 },
    позвоночник_наклон_вперед: { offset: 0 },
    позвоночник_поворот: { offset: 0 },
};

export default initialMuscleRotations;
